import { RouteConfig } from "@/routes/types/route.types.ts";
import { FormResultPrintWrapper } from "@/pages/print/FormResultPrintWrapper.tsx";
import { FeedbackPrintPage } from "@/pages/print/FeedbackPrintPage.tsx";
import { SurveySummaryPrintPage } from "@/pages/talent/surveys/view/SurveySummaryPrintPage.tsx";
import { ApiFormType } from "@/types/forms/form.types.ts";

export const printRoutes: RouteConfig[] = [
  {
    path: "/print",
    children: [
      {
        path: "form-result/survey/:id/:employee_id",
        element: <FormResultPrintWrapper form_type={ApiFormType.survey} />,
        isFullScreen: true,
      },
      {
        path: "form-result/feedback/:id/:employee_id",
        element: <FeedbackPrintPage />,
        isFullScreen: true,
      },
      {
        path: "form-result/performance-review/:id/:employee_id",
        element: <FormResultPrintWrapper form_type={ApiFormType.performanceReview} />,
        isFullScreen: true,
      },
      { path: "survey-view/:id/:step", element: <SurveySummaryPrintPage />, isFullScreen: true },
    ],
  },
];
